import { CandidateFilters } from "@/model/candidate";

export const defaultCandidateFilterFields: CandidateFilters = {
  search: "",
  channel_id: "",
  department_id: "",
  skill: "",
  source_id: "",
  status: "",
  created_by: "",
  responsible_recruiter_id: "",
  created_at_from: "",
  created_at_to: "",
  limit: "20",
  offset: "0",
  sort_column: "candidate.created_at",
  sort_direction: undefined,
};
